import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { HealthAuthProvider, useHealth } from "@/context/HealthAuthContext";
import HealthLanding from "@/pages/health/HealthLanding";
import HealthLogin from "@/pages/health/HealthLogin";
import HealthSignup from "@/pages/health/HealthSignup";
import HealthDashboard from "@/pages/health/HealthDashboard";
import { Loader2 } from "lucide-react";

function Guard({ children }) {
  const { state } = useHealth();
  if (state === null) return <div className="h-screen grid place-items-center bg-emerald-50"><Loader2 className="h-6 w-6 animate-spin text-emerald-600" /></div>;
  if (state === false) return <Navigate to="/health/login" replace />;
  return children;
}

export default function HealthApp() {
  return (
    <HealthAuthProvider>
      <Routes>
        <Route index element={<HealthLanding />} />
        <Route path="login" element={<HealthLogin />} />
        <Route path="signup" element={<HealthSignup />} />
        <Route path="app" element={<Guard><HealthDashboard /></Guard>} />
        <Route path="*" element={<Navigate to="/health" replace />} />
      </Routes>
    </HealthAuthProvider>
  );
}
